import { useMsal } from '@azure/msal-react';
import {
    Backdrop, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, Grid, IconButton,
    InputAdornment, makeStyles, TablePagination, TableSortLabel, TextField, Typography, useMediaQuery, useTheme
} from '@material-ui/core';
import { Paper, styled, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import _ from 'lodash';
import * as React from 'react';
import { CSVLink } from "react-csv";
import PuffLoader from "react-spinners/PuffLoader";
import '../App.css';
// Icons
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from '@mui/icons-material/Close';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import download from "../images/files/download01.svg";
// Components
import Footer from '../components/Footer/Footer';
import LightTooltip from "../components/GlobalStyles/LightTooltip";
import RollExpandableRow from '../components/Roll/RollExpandableRow';
import VideoPlayer from '../components/YouTubePlayer/VideoPlayer';
// Models
import { useEffect, useRef, useState } from 'react';
import { DialogTitleHeader } from '../components/GlobalStyles/DialogStyle';
import * as constant from '../constants/Constant';
import { IDebtor } from '../models/Roll/IDebtor';
import { DebtorNumberList, IRollAll } from "../models/Roll/IRollAll";
import { IRollClients } from '../models/Roll/IRollClients';
import { useGlobalState } from '../store/GlobalStore';
import { useFetch, usePost } from '../utils/apiHelper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { IReportStatusList } from '../models/Reports/IReportStatusList';
import ReplayIcon from "@material-ui/icons/Replay";
import { IAckClientInfo } from '../models/IAckReport/IAckClientInfo';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    div: {
        flexGrow: 1,
        padding: '8px',
        overflow: 'hidden',
    },
    grid: {
        display: "flex",
        justifyContent: "left",
        justifyItems: "left"
    },
    progressBar: {
        height: '6px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    searchBar: {
        marginTop: '2px',
        borderRadius: "30px",
        border: '2px solid #215176',
        height: '38px',
        textIndent: '10px',
        boxShadow: '0px 1px 4px 1px rgba(103, 128, 159, 1)',
    },
    tablebody: {
        maxHeight: 495,
        minHeight: 495,
        marginTop: '-5px',
        overflowX: 'hidden',
        [theme.breakpoints.up('lg')]: {
            maxHeight: 'calc( 100vh - 215px)',
            minHeight: 'calc( 100vh - 215px)',
        },
        '& .MuiTableContainer-root': {
            overflowX: 'hidden'
        }
    },
    label: {
        '&$focused': {
            color: 'white',
            border: '0px'
        },
    },
    outlinedInput: {
        fontSize: 15,
        color: "black",
        marginTop: '-3px',
        '&$focused $notchedOutline': {
            color: 'white',
            border: '0px'
        },
    },
    outlinedInput1: {
        fontSize: 15,
        color: "black",
        marginTop: '4px !important',
        paddingLeft: '10px',
        '&$focused $notchedOutline': {
            color: 'white',
            border: 'none',
        },
    },
    notchedOutline1: {
        color: 'white',
        border: '0px'
    },
    TableHeaderStyle: {
        background: "#007FFF",
        color: "white",
        height: '30px',
        padding: '10px 5px 5px 10px',
        fontSize: 11
    },
    textStyle: {
        marginTop: '5px',
        marginLeft: '5px',
        float: 'left'
    },
    leftbutton: {
        borderRadius: 20,
        background: "#FF0000",
        fontSize: 12,
        color: "white",
        marginTop: '7px',
        textAlign: 'left',
        marginRight: '10px',
        '&:hover': {
            background: "#FF0000",
        }
    },
    rollbutton: {
        borderRadius: 20,
        fontSize: 12,
        color: "white",
        marginTop: '7px',
        marginRight: '10px',
    },
    rollundobutton: {
        borderRadius: 20,
        fontSize: 12,
        color: "white",
        marginTop: '7px',
        backgroundColor: '#FF0000',
        '&:hover': {
            background: "#FF0000",
        },
        marginRight: '10px'
    },
    gridContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '10px'
    },
    titleHeader: {
        fontWeight: 'bold',
        marginTop: '5px',
        color: 'white',
        fontSize: 18
    },
    footer: {
        marginTop: '15px',
        float: 'right',
        marginRight: '70px'
    },
    norecord: {
        color: "red",
        marginTop: "10px",
        textAlign: "center"
    },
    title: {
        textAlign: 'left'
    },
    fabProgressPrint: {
        color: 'green',
        position: 'absolute',
        top: 6,
        left: 6,
        zIndex: 1
    },
    videoplayer: {
        marginTop: '1.05cm',
        marginLeft: '10px'
    },
    yesButton: {
        background: "green",
        color: 'white',
        borderRadius: 20,
        bottom: '0.1cm',
        right: '15px',
        fontSize: 12,
        '&:hover': {
            background: "green",
        }
    },
    noButton: {
        background: "red",
        borderRadius: 20,
        display: 'flex',
        right: '10px',
        bottom: '0.1cm',
        fontSize: 12,
        '&:hover': {
            background: "red",
        }
    },
    SearchDropdown: {
        marginLeft: '0.2cm'
    },
    paper1: {
        border: "2px solid black",
        fontSize: 12
    },
    autoCompleteFont: {
        fontSize: 13,
        padding: '4px 12px'
    },
    placeholder: {
        '&::placeholder': {
            fontSize: '16px',
        },
    },
    dropDownStyle: {
        marginTop: '2px',
        boxShadow: '0px 1px 4px 1px rgba(103, 128, 159, 1)',
        borderRadius: 5,
        border: '2px solid #215176',
        backgroundColor: 'white',
        height: '38px',
        fontSize: 12,
        width: '100%'
    },
    replyIcon: {
        padding: '2px 2px',
        marginLeft: '5px',
        paddingTop: '5px',
    },
    GreenColor: {
        color: 'green',
    },
}))

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        background: "#007FFF",
        color: theme.palette.common.white,
        padding: '1px 5px',
        fontSize: 9.5,
        textTransform: 'uppercase',
        fontWeight: 'bold',

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 10,
        padding: 0
    }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0
    }
}));

const headCells = [
    { id: "dbT_CLIENT", numeric: false, disablePadding: false, label: "CLIENT ID", sortable: true, minWidth: 200 },
    { id: "clT_NAME_1", numeric: false, disablePadding: false, label: "CLIENT NAME 1", sortable: true },
    { id: "clT_NAME_2", numeric: false, disablePadding: false, label: "CLIENT NAME 2", sortable: true },
    { id: "dbT_NO", numeric: false, disablePadding: false, label: "AGENCY ID", sortable: true },
    { id: "dbT_CLNT_ACNT1", numeric: false, disablePadding: false, label: "ACCOUNT ID", sortable: true },
    { id: "dbT_NAME", numeric: false, disablePadding: false, label: "NAME", sortable: true },
    { id: "deM_PHONE1", numeric: false, disablePadding: false, label: "PHONE No", sortable: true },
    { id: "dbT_REFERRAL_DATE", numeric: false, disablePadding: false, label: "ACCOUNT AGING", sortable: true },
    { id: "dbT_REFERRAL_AMT", numeric: false, disablePadding: false, label: "REFERRED AMOUNT", sortable: true },
    { id: "dbT_PRINCIPAL_DUE", numeric: false, disablePadding: false, label: "BALANCE", sortable: true },
    { id: "stS_DESC", numeric: false, disablePadding: false, label: "STATUS", sortable: true },
    { id: "dbT_STATUS_DATE", numeric: false, disablePadding: false, label: "STATUS DATE", sortable: true, alignItems: 'flex-end' },
    { id: "", numeric: false, disablePadding: false, label: "ADVANCE TO CONT", sortable: false },
    { id: "", numeric: false, disablePadding: false, label: "REMOVE", sortable: false }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;

    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <StyledTableRow>
                <StyledTableCell>
                    {/* <Checkbox size='small' color='primary' /> */}
                </StyledTableCell>
                {headCells.map(headCell => (
                    <StyledTableCell key={headCell.id} style={{ minWidth: `${headCell.minWidth}`, alignItems: `${headCell.alignItems}` }} sortDirection={orderBy === headCell.id ? order : false} className={classes.TableHeaderStyle} >
                        <TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : "asc"} onClick={createSortHandler(headCell.id)}>
                            {headCell.label || headCell.sortable}
                            {orderBy === headCell.id || headCell.sortable ? (
                                <span className={classes.visuallyHidden}>
                                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </StyledTableCell>
                ))}
            </StyledTableRow>
        </TableHead>
    );
}

export default function ComparatorSortingGrid() {
    const theme = useTheme();
    const classes = useStyles();
    const prevDBTNo = useRef("");
    const { accounts } = useMsal();
    const wrapperRef = useRef(null);
    const { state } = useGlobalState();
    const [page, setPage] = useState(0);
    const [count, setCount] = useState<number>(0);
    const [order, setOrder] = useState<any>('desc');
    const [mapcount, setMapCount] = useState(false);
    const [isRollall, setIsRollall] = useState(false);
    const [selected, setSelected] = useState<string>();
    const [expLoading, setExpLoading] = useState(false);
    const [ExportData, setExportData] = useState<any>([]);
    const [rollList, setRollList] = useState<IDebtor[]>([]);
    const [searchText, setSearchText] = useState<string>('');
    const [ProgressBar, setshowProgressBar] = useState(true);
    const [triggerSearch, setTriggerSearch] = useState(false);
    const [showSearchIcon, setShowSearchIcon] = useState(true);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [confirmedClients, setConfirmedClients] = useState([]);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [reportStatusId, setReportStatusId] = useState<string>('');
    const [orderBy, setOrderBy] = useState<string>("dbT_REFERRAL_DATE");
    const [selectedClientCode, setSelectedClientCode] = useState<string>('');
    const [isRollSelectedaccounts, setIsRollSelectedaccounts] = useState(false);
    const [reportStatusList, setReportStatusList] = useState<IReportStatusList[]>([]);
    const [isUndoSelectedAccounts, setIsUndoSelectedAccounts] = useState<boolean>(false);
    const [selectedAccountList, setSelectedAccountList] = useState<DebtorNumberList[]>([]);
    const [selectedRolledAccountList, setSelectedRolledAccountList] = useState<DebtorNumberList[]>([]);

    const handleCheckboxChange = (debtorNumber, isRolled) => {
        if (isRolled) {
            setSelectedRolledAccountList(prevList => {
                const exists = prevList.some(x => x.debtorNumber === debtorNumber);
                return exists
                    ? prevList.filter(x => x.debtorNumber !== debtorNumber)
                    : [...prevList, { debtorNumber }];
            });
        } else {
            setSelectedAccountList(prevList => {
                const exists = prevList.some(x => x.debtorNumber === debtorNumber);
                return exists
                    ? prevList.filter(x => x.debtorNumber !== debtorNumber)
                    : [...prevList, { debtorNumber }];
            });
        }
    };

    const handleReportStatusChange = (event, selected) => {
        if (selected?.statusCode === undefined || !selected?.statusCode?.length) {
            setReportStatusId('');
        } else {
            setReportStatusId(selected?.statusCode);
        }
    }

    const handleClientCodeChange = (event, selected) => {
        if (selected?.client_code === undefined || !selected?.client_code?.length) {
            setSelectedClientCode('');
        } else {
            setSelectedClientCode(selected?.client_code);
        }
    }
    const headers = [
        { label: "DBT_COMPANY", key: "dbT_COMPANY" },
        { label: "DBT_CLIENT", key: "dbT_CLIENT" },
        { label: "DBT_NO", key: "dbT_NO" },
        { label: "DBT_CLNT_ACNT1", key: "dbT_CLNT_ACNT1" },
        { label: "CLIENT_NAME_1", key: "clT_NAME_1" },
        { label: "CLIENT_NAME_2", key: "clT_NAME_2" },
        { label: "DBT_NAME", key: "dbT_NAME" },
        { label: "DBT_REFERRAL_DATE", key: "dbT_REFERRAL_DATE" },
        { label: "DBT_REFERRAL_AMT", key: "dbT_REFERRAL_AMT" },
        { label: "DBT_PRINCIPAL_DUE", key: "dbT_PRINCIPAL_DUE" },
        { label: "DBT_STATUS_DATE", key: "dbT_STATUS_DATE" },
        { label: "STS_DESC", key: "stS_DESC" },
        { label: "rolled", key: "rolled" },
        { label: "manually_rolled", key: "manually_rolled" },
        { label: "removed", key: "removed" },
        { label: "update_date", key: "update_date" }
    ];

    const handleCancelConfirmation = () => {
        setIsRollall(false);
        setIsRollSelectedaccounts(false);
    }

    const handleRowClick = (accountId: string) => {
        setSelected(selected == accountId ? "" : accountId);
        prevDBTNo.current = accountId;
    }

    useEffect(() => {
        getRollListAsync();
    }, [page, orderBy, order, reportStatusId, selectedClientCode]);

    useEffect(() => {
        (async () => {
            await useFetch<IReportStatusList[]>("GetRollReportStatusList").then((result) => {
                setReportStatusList(result?.data);
            }).finally(() => {
            });
        })()
    }, [])

    const handleGetClientCodeList = () => {
        (async () => {
            let request = {
                "userId": state?.userAccessContext?.id,
                "client_code": "",
                "isAdmin": (state?.userAccessContext.role === 0 || state?.userAccessContext.role === 1) ? false : true
            }
            await usePost<IAckClientInfo[]>("Client/searchAckClientCode", request).then((r) => {
                setConfirmedClients(r.data);
            }).finally(() => {
            });
        })()
    };

    async function getRollListAsync() {
        let GetClients: IRollClients[] = [];
        if (state?.userAccessContext?.clientCodes?.length) {
            state?.userAccessContext?.clientCodes?.map((x, index) => {
                let ClientDetail: IRollClients = { clientCodes: x };
                GetClients.push(ClientDetail);
            });
        } else {
            let requestAccount = { "email": accounts[0]?.username }
            await usePost<any>("GetUserClientCode", requestAccount).then((userAcc) => {
                GetClients = userAcc?.data;
            });
        }

        let request = {
            "userId": state?.userAccessContext?.id,
            "searchText": searchText?.trim().split(" ")[0] ?? "",
            "orderBy": orderBy,
            "to": 15,
            "orderDirection": order === "desc" ? 1 : 0,
            "startingRecordNumber": (page * 15) + 1,
            "reportStatus": reportStatusId,
            "selectedClientCode": selectedClientCode
        };
        setshowProgressBar(true);
        await usePost<{ rollList: IDebtor[], qty: number, remaining: number }>("GetRollDetails", request).then((rollList) => {
            setRollList(rollList.data["rollList"]);
            setMapCount(!rollList.data.qty.toString() === undefined ? false : true);
            setTotalRecords(rollList.data.qty === undefined ? 0 : rollList.data.qty);
            const isAnyRolled = rollList?.data["rollList"]?.some((result) => result.rolled);
            setIsUndoSelectedAccounts(isAnyRolled);
        }).finally(() => {
            setshowProgressBar(false);
        });
    }

    const handleRequestSort = (event, property) => {
        setshowProgressBar(true);
        const isAsc = orderBy === property && order === "asc";
        setPage(0);
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setshowProgressBar(true);
        setPage(newPage);
    };

    const initiateSearch = () => {
        setPage(0);
        setTriggerSearch(!triggerSearch);
        setshowProgressBar(true);
        getRollListAsync();
        ExportDetails();
    }
    const cancelSearch = () => {
        setshowProgressBar(true);
        setShowSearchIcon(true);
        getRollListAsyncClear();
        ClearExportDetails();
        setSearchText('');
    }

    useEffect(() => {
        handleGetClientCodeList();
        GetRemainingCount();
    }, [])

    const GetRemainingCount = () => {
        (async () => {
            let GetClients: IRollClients[] = [];
            if (state?.userAccessContext?.clientCodes?.length) {
                state?.userAccessContext?.clientCodes?.map((x, index) => {
                    let ClientDetail: IRollClients = { clientCodes: x };
                    GetClients.push(ClientDetail);
                });
            } else {
                let requestAccount = { "email": accounts[0]?.username }
                await usePost<any>("GetUserClientCode", requestAccount).then((userAcc) => {
                    GetClients = userAcc?.data;
                });
            }
            let request = {
                "rollClients": _.cloneDeep(GetClients)
            }
            await usePost<any>("GetRemainingCount", request).then(r => {
                setCount(r.data?.remaining);
            });
        })()
    }

    async function getRollListAsyncClear() {
        let GetClients: IRollClients[] = [];
        if (state?.userAccessContext?.clientCodes?.length) {
            state?.userAccessContext?.clientCodes?.map((x, index) => {
                let ClientDetail: IRollClients = { clientCodes: x };
                GetClients.push(ClientDetail);
            });
        } else {
            let requestAccount = { "email": accounts[0]?.username }
            await usePost<any>("GetUserClientCode", requestAccount).then((userAcc) => {
                GetClients = userAcc?.data;
            });
        }

        let request = {
            "userId": state?.userAccessContext?.id,
            "searchText": "",
            "orderBy": orderBy,
            "to": 15,
            "orderDirection": order === "desc" ? 1 : 0,
            "startingRecordNumber": (page * 15) + 1,
            "reportStatus": reportStatusId,
            "selectedClientCode": selectedClientCode
        };
        setshowProgressBar(true);
        await usePost<{ rollList: IDebtor[], qty: number }>("GetRollDetails", request).then((rollList) => {
            setRollList(rollList.data["rollList"]);
            setMapCount(!rollList.data.qty.toString() === undefined ? false : true);
            setTotalRecords(rollList.data.qty === undefined ? 0 : rollList.data.qty);
            const isAnyRolled = rollList?.data["rollList"]?.some((result) => result.rolled);
            setIsUndoSelectedAccounts(isAnyRolled);
        }).finally(() => {
            setshowProgressBar(false);
        });
    }

    const ClearExportDetails = () => {
        (async () => {
            let GetClients: IRollClients[] = [];
            if (state?.userAccessContext?.clientCodes?.length) {
                state?.userAccessContext?.clientCodes?.forEach((x, index) => {
                    if (x && (x != "" || x != null)) {
                        let ClientDetail: IRollClients = { clientCodes: x };
                        GetClients.push(ClientDetail);
                    }
                });
            } else {
                let requestAccount = { "email": accounts[0]?.username }
                await usePost<any>("GetUserClientCode", requestAccount).then((userAcc) => {
                    GetClients = userAcc?.data;
                });
            }
            let request = {
                "rollClients": _.cloneDeep(GetClients),
                "orderBy": orderBy,
                "dir": order === "desc" ? "desc" : "asc",
                "to": 200000,
                "reportStatus": reportStatusId,
                "searchParameters": "",
                "selectedClientCode": selectedClientCode
            };
            await usePost<any>("RollExportDetails", request).then((r) => {
                setExportData(r.data);
            });
        })()
    }

    const RollAll = () => {
        (async () => {
            setIsRollall(false);
            setshowProgressBar(true);
            let request = {
                "clientCode": state.userAccessContext?.clientCodes.join(","),
                "user_Id": state.userAccessContext?.id,
                "accountStatus": reportStatusId
            };
            await usePost<IRollAll[]>('RollAll', request).finally(() => {
                getRollListAsync();
            }).finally(() => {
                GetRemainingCount();
                setshowProgressBar(false);
            });
        })()
    }

    useEffect(() => {
        setExpLoading(true);
        (async () => {
            let GetClients: IRollClients[] = [];
            if (state?.userAccessContext?.clientCodes?.length) {
                state?.userAccessContext?.clientCodes?.forEach((x, index) => {
                    if (x && (x != "" || x != null)) {
                        let ClientDetail: IRollClients = { clientCodes: x };
                        GetClients.push(ClientDetail);
                    }
                });
            } else {
                let requestAccount = { "email": accounts[0]?.username }
                await usePost<any>("GetUserClientCode", requestAccount).then((userAcc) => {
                    GetClients = userAcc?.data;
                });
            }

            let request = {
                "rollClients": _.cloneDeep(GetClients),
                "orderBy": orderBy,
                "dir": order === "desc" ? "desc" : "asc",
                "to": 200000,
                "reportStatus": reportStatusId,
                "searchParameters": searchText?.trim() ?? "",
                "selectedClientCode": selectedClientCode
            };
            await usePost<any>("RollExportDetails", request).then((r) => {
                setExportData(r.data);
            });
        })().finally(() => {
            setExpLoading(false);
        })
    }, [reportStatusId, selectedClientCode]);

    const ExportDetails = () => {
        setExpLoading(true);
        (async () => {
            let GetClients: IRollClients[] = [];
            if (state?.userAccessContext?.clientCodes?.length) {
                state?.userAccessContext?.clientCodes?.forEach((x, index) => {
                    if (x && (x != "" || x != null)) {
                        let ClientDetail: IRollClients = { clientCodes: x };
                        GetClients.push(ClientDetail);
                    }
                });
            } else {
                let requestAccount = { "email": accounts[0]?.username }
                await usePost<any>("GetUserClientCode", requestAccount).then((userAcc) => {
                    GetClients = userAcc?.data;
                });
            }

            let request = {
                "rollClients": _.cloneDeep(GetClients),
                "orderBy": orderBy,
                "dir": order === "desc" ? "desc" : "asc",
                "to": 200000,
                "reportStatus": reportStatusId,
                "searchParameters": searchText?.trim() ?? "",
                "selectedClientCode": selectedClientCode
            };

            await usePost<any>("RollExportDetails", request).then((r) => {
                setExportData(r.data);
            });
        })().finally(() => {
            setExpLoading(false);
        })
    }

    const RollSelectedAccounts = () => {
        setshowProgressBar(true);
        (async () => {
            setIsRollSelectedaccounts(false);
            let request = {
                "selectedDebtorNumber": selectedAccountList,
                "user_Id": state.userAccessContext?.id,
            };
            await usePost<IRollAll[]>('RollSelectedAccounts', request).finally(() => {
            }).finally(() => {
                GetRemainingCount();
                getRollListAsync();
                setSelectedAccountList([]);
                setSelectedRolledAccountList([]);
            });
        })()
    }

    const undoSelectedRolledAccounts = () => {
        (async () => {
            let request = {
                "selectedDebtorNumber": selectedRolledAccountList,
                "user_Id": state.userAccessContext?.id,
            };
            await usePost<any>('UndoRolledAccounts', request).then(() => {
            }).finally(() => {
                GetRemainingCount();
                getRollListAsync();
                setSelectedAccountList([]);
                setSelectedRolledAccountList([]);
            });
        })()
    }

    return (
        <React.Fragment>
            <div className={classes.div} ref={wrapperRef}>
                <Backdrop className={classes.backdrop} open={ProgressBar}>
                    <PuffLoader size={80} color={"white"} speedMultiplier={1} />
                </Backdrop>
                <Grid container className={classes.grid}>
                    <Grid item xs={1} sm={1}>
                        <Typography variant="h5" gutterBottom className={`${classes.textStyle} ${"headertitle"}`}>
                            <b>ROLL LIST</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <TextField value={searchText}
                            fullWidth
                            size="small"
                            id="standard-bare"
                            variant="outlined"
                            type='text' placeholder="Search (account number, name, SSN, phone)"
                            className={classes.searchBar}
                            inputProps={{ maxLength: 255 }}
                            onChange={e => setSearchText(e.target.value)}
                            onKeyPress={event => {
                                if (event.key === 'Enter' && searchText != "") {
                                    initiateSearch(); setShowSearchIcon(false);
                                } else if (event.key === 'Enter' && searchText === "") {
                                    initiateSearch(); setShowSearchIcon(true);
                                }
                            }}
                            InputProps={{
                                classes: {
                                    root: classes.outlinedInput,
                                    notchedOutline: classes.notchedOutline1,
                                },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {showSearchIcon === true ?
                                            <IconButton onClick={e => { initiateSearch(); setShowSearchIcon(false); }} style={{ marginLeft: '1.5cm' }}>
                                                <SearchIcon />
                                            </IconButton>
                                            :
                                            <IconButton onClick={e => { cancelSearch(); }} style={{ marginLeft: '1.5cm' }}>
                                                <CloseIcon />
                                            </IconButton>
                                        }
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Autocomplete
                            id="combo-box-demo"
                            size='small' fullWidth
                            className={classes.SearchDropdown}
                            classes={{
                                paper: classes.paper1,
                                option: classes.autoCompleteFont
                            }}
                            options={reportStatusList?.map(option => ({ statusCode: option.statusCode, statusName: option.statusName }))}
                            getOptionLabel={(option) => option.statusName}
                            getOptionSelected={(option, value) => option.statusName === value.statusName}
                            onChange={(e, selected) => { handleReportStatusChange(e, selected); }}
                            renderOption={(option) => (
                                <React.Fragment>
                                    {option?.statusCode} -- {option.statusName}
                                </React.Fragment>
                            )}
                            renderInput={(params) =>
                                <TextField
                                    placeholder="Filter By Status"
                                    {...params}
                                    className={classes.dropDownStyle}
                                    InputProps={{
                                        ...params.InputProps, disableUnderline: true,
                                        classes: {
                                            root: classes.outlinedInput1
                                        }
                                    }}
                                />}
                        />
                    </Grid>
                    <Grid item xs={6} md={2} style={{ marginLeft: '0px' }}>
                        <Autocomplete
                            id="combo-box-demo"
                            options={confirmedClients}
                            fullWidth size='small'
                            className={classes.SearchDropdown}
                            classes={{
                                paper: classes.paper1,
                                option: classes.autoCompleteFont
                            }}
                            getOptionLabel={(option) => option?.client_code}
                            getOptionSelected={(option, value) => option?.client_code == value?.client_code}
                            onChange={(e, selected) => { handleClientCodeChange(e, selected); }}
                            renderOption={(option, { selected }) => (
                                <span className={`${selected ? classes.GreenColor : null}`} style={{ fontSize: 12, marginLeft: '5px' }}>
                                    <div style={{ fontWeight: 'bold', display: 'inline' }}> {option?.client_code} </div>
                                    {" -- " + option?.client_name}
                                </span>
                            )}
                            renderInput={(params) =>
                                <TextField
                                    placeholder="Client Code"
                                    {...params}
                                    className={classes.dropDownStyle}
                                    InputProps={{
                                        ...params.InputProps, disableUnderline: true,
                                        classes: {
                                            root: classes.outlinedInput1
                                        }
                                    }}
                                />}
                        />
                    </Grid>
                    <Grid item xs={4} sm={3} >
                        <Grid container className={classes.gridContainer}>
                            <Button id="Roll_RollCount" className={classes.leftbutton} size="small" variant="contained">
                                {count === 0 ? 0 : count} Left
                            </Button>
                            {selectedAccountList?.length ?
                                <Button id="Roll_RollAll_Button" startIcon={<SupervisorAccountIcon />} className={classes.rollbutton} size="small" variant="contained" color="primary"
                                    onClick={(_) => { setIsRollSelectedaccounts(true); }} disabled={!state.userAccessContext?.rollAccounts || !rollList.length || !count}>
                                    Roll
                                </Button>
                                :
                                <Button id="Roll_RollAll_Button" startIcon={<SupervisorAccountIcon />} className={classes.rollbutton} size="small" variant="contained" color="primary"
                                    onClick={(_) => { setIsRollall(true); }} disabled={!state.userAccessContext?.rollAccounts || !rollList.length || !count}>
                                    Roll All
                                </Button>
                            }
                            {isUndoSelectedAccounts && selectedRolledAccountList?.length ?
                                <Button id="Roll_Undo_btn" startIcon={<ReplayIcon style={{ fontSize: 20 }} />} className={classes.rollundobutton} size="small" variant="contained"
                                    onClick={(_) => { undoSelectedRolledAccounts(); }} disabled={!state.userAccessContext?.rollAccounts || !rollList.length || !count}>
                                    Undo
                                </Button>
                                : null
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={4} sm={1}>
                        <Box alignItems="flex-end" display="flex" justifyContent="flex-end">
                            <Box display="flex">
                                <LightTooltip title="Download Roll List">
                                    <IconButton id="Roll_DownloadCSV" aria-label="Roll_DownloadCSV" disabled={!rollList.length} style={{ borderRadius: 50 }}>
                                        <CSVLink
                                            data={ExportData}
                                            headers={headers}
                                            filename={"RollList.csv"}
                                            className="btn btn-primary"
                                            target="_blank" >
                                            <img src={download} alt="Icon for Download" width="30px" height="28px" style={!ExportData.length ? { color: 'gray', fontSize: 42 } : { color: "#007FFF", fontSize: 42 }} /* fontSize="large" */ />
                                        </CSVLink>
                                        {expLoading && <CircularProgress size={45} className={classes.fabProgressPrint} />}
                                    </IconButton>
                                </LightTooltip>
                            </Box>
                            <Box display="flex" style={{ marginTop: '45px', }} >
                                {/* <VideoPlayer video={videoFile} title={videoPlacementTitle} /> */}
                            </Box>
                        </Box>
                    </Grid >
                </Grid >

                <Paper>
                    <TableContainer component={Paper} className={`${classes.tablebody} ${"scrollbox"} ${"on-scrollbar"}`}>
                        <Table sx={{ minWidth: 650 }} aria-label="customized table" size="small" stickyHeader>
                            <EnhancedTableHead classes={classes} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
                            <TableBody>
                                {rollList?.map(
                                    (row) => {
                                        return (
                                            <RollExpandableRow onClick={handleRowClick} selected={selected === row.dbT_NO}
                                                key={row.dbT_NO} onDelete={getRollListAsync} onRollRemove={getRollListAsync}
                                                onUndoCloseRemove={getRollListAsync} onEroll={getRollListAsync} row={row} onCheckboxChange={handleCheckboxChange}
                                                selectedDBTNumber={selected} searchWord={searchText} GetCount={GetRemainingCount}
                                                isItemSelected={selectedAccountList.some(x => x.debtorNumber === row?.dbT_NO) || selectedRolledAccountList.some(x => x.debtorNumber === row?.dbT_NO)}
                                            />
                                        );
                                    })}
                            </TableBody>
                        </Table>
                        {!ProgressBar && !rollList.length ?
                            < Typography variant="h6" gutterBottom className={classes.norecord}>
                                No records to display..
                            </Typography>
                            : null}
                    </TableContainer>
                    <Grid container spacing={0}>
                        <Box m={0} width="65%">
                            <div className="footer">
                                <Footer />
                            </div>
                        </Box>
                        <Box m={0} width="35%">
                            <div className="pagination">
                                <TablePagination
                                    id="Roll_TablePagination"
                                    rowsPerPageOptions={[15]}
                                    component="div"
                                    count={totalRecords}
                                    rowsPerPage={15}
                                    page={page}
                                    onChangePage={handleChangePage}
                                />
                            </div>
                        </Box>
                    </Grid>
                </Paper >

                <Dialog PaperProps={{ style: { borderRadius: 15 } }} maxWidth={'sm'} fullScreen={fullScreen} open={isRollall} onClose={handleCancelConfirmation} aria-labelledby="responsive-dialog-title" >
                    <DialogTitleHeader id="responsive-dialog-title" onClose={handleCancelConfirmation}>
                        <Typography variant="h6" gutterBottom className={classes.titleHeader}>
                            ROLL ALL
                        </Typography>
                    </DialogTitleHeader>
                    <DialogContent>
                        <Typography variant="h6" style={{ color: "black" }} gutterBottom>
                            Are you sure, you want to roll all the accounts?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button id="IM_ok_btn" size="small" variant="contained" onClick={() => { RollAll(); }} className={classes.yesButton} color="primary" autoFocus>
                            Yes
                        </Button>
                        <Button id="IM_Cancel_Btn" size="small" variant="contained" autoFocus className={classes.noButton} onClick={handleCancelConfirmation} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog PaperProps={{ style: { borderRadius: 15 } }} maxWidth={'sm'} fullScreen={fullScreen} open={isRollSelectedaccounts} onClose={handleCancelConfirmation} aria-labelledby="responsive-dialog-title" >
                    <DialogTitleHeader id="responsive-dialog-title" onClose={handleCancelConfirmation}>
                        <Typography variant="h6" gutterBottom className={classes.titleHeader}>
                            ROLL ALL
                        </Typography>
                    </DialogTitleHeader>
                    <DialogContent>
                        <Typography variant="h6" style={{ color: "black" }} gutterBottom>
                            Are you sure, you want to roll the selected accounts?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button id="IM_ok_btn" size="small" variant="contained" onClick={() => { RollSelectedAccounts(); }} className={classes.yesButton} color="primary" autoFocus>
                            Yes
                        </Button>
                        <Button id="IM_Cancel_Btn" size="small" variant="contained" autoFocus className={classes.noButton} onClick={handleCancelConfirmation} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div >
        </React.Fragment >
    )
}